import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_ServicepackageListComponent from "../components/_FM_servicepackage/_FM_ServicepackageListComponent";
import _FM_ServicepackageFormComponent from "../components/_FM_servicepackage/_FM_ServicepackageFormComponent";
import _FM_ServicepackageShowComponent from "../components/_FM_servicepackage/_FM_ServicepackageShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_ServicepackagePage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();

  useEffect(() => {
    document.title = t('service_packages') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/service-package');
  }, []);

  return (
    <div className="_FM_ServicepackagePage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/service-package"}/>
      <Panel>
        <_FM_ServicepackageListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/service-package');
               }}>
        <_FM_ServicepackageFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/service-package');
               }}>
        <_FM_ServicepackageShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_ServicepackagePage);
